// What accepting a maintenance option writes (#515 slice 1b): its year-lettered lines, year by year, as
// the server will write them (the same @higgins/m2q-pricing code re-prices it there). A financed contract's
// lines sell its year payments, interest included, at the same cost (slice 3).
import { maintenanceOpportunityLines, YEAR_LETTERS, yearPayments, type PricedOption, type PricingRates } from '@higgins/m2q-pricing';
import type { MaintenancePricing } from '../lib/maintenance-pricing';
import { formatMoney, formatTwo } from './surface-format';

interface Props {
  pricing: MaintenancePricing;
  priced: PricedOption;
  rates: PricingRates;
  labourType: string;
}

export function YearLinesPreview({ pricing, priced, rates, labourType }: Props) {
  const types = { labourType, servicingLabourType: pricing.servicingLabourType || labourType };
  const lines = maintenanceOpportunityLines(priced, pricing.contract, rates, types, yearPayments(pricing.yearly));
  return (
    <details className="mb-2 text-xs">
      <summary className="cursor-pointer text-slate-600">
        The {lines.length} lines it writes, {pricing.years} years ({lines[0]?.productNumber} … {lines[lines.length - 1]?.productNumber})
      </summary>
      <table className="mt-1 tabular-nums">
        <thead>
          <tr className="text-slate-500">
            <th className="pr-3 text-left font-normal">Year</th>
            <th className="pr-3 text-left font-normal">Product</th>
            <th className="pr-3 text-right font-normal">Sell</th>
            <th className="pr-3 text-right font-normal">Cost</th>
            <th className="text-right font-normal">Hrs / Lts</th>
          </tr>
        </thead>
        <tbody>
          {lines.map((l) => (
            <tr key={l.sequence}>
              <td className="pr-3">{pricing.startYear + YEAR_LETTERS.indexOf(l.productNumber.charAt(0))}</td>
              <td className="pr-3">{l.productNumber}</td>
              <td className="pr-3 text-right">{formatMoney(l.sell)}</td>
              <td className="pr-3 text-right">{formatMoney(l.cost)}</td>
              <td className="text-right">{l.hoursLitres === null ? '' : formatTwo(l.hoursLitres)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </details>
  );
}
